export interface TenantDescription {
  tenantId: string;
  tenantDescription: string;
}

export const hardCodedDomains: Record<string, string> = {
  'mjoll.no': 'mjoll',
  'mediability.no': 'mediability',
  'craftsmenltd.com': 'craftsmenltd',
  'example.com': 'example',
  'foxnews.com': 'foxnews',
  'akerbp.com': 'akerbp',
  'axelspringer.com': 'axelspringer',
  'axelspringerstaging.mimir.tv': 'axelspringerstaging',
  'hivolda.mimir.tv': 'hivolda',
  'emerson.edu': 'emerson',
  'tvnz.co.nz': 'tvnz',
  'tvnzsandbox.mimir.tv': 'tvnzsandbox',
  'tvsyd.dk': 'tvsyd',
  'ap.org': 'apnews',
  'apstaging.org': 'apnewsstaging',
  'nepgrouptest.com': 'nepnltst',
  'nepgroup.com': 'nentnl',
  'dpa.com': 'dpa',
  'dpastage.com': 'dpastage',
  'tv2fyn.dk': 'tv2fyn',
  'havasstudios.com': 'havasstudios',
  'f1.com': 'f1demo',
  'abc.online': 'abconline',
  'nrk.no': 'nrk',
  'volantmedia.net': 'volantmedia',
  'wsj.com': 'wsj',
  'nyt.com': 'nyt',
  'fulwell73.com': 'fulwell73',
  'tv2east.dk': 'tv2east',
  'cbsnews.com': 'cbsnews',
  'nine.com.au': 'ch9aus',
  'relevant.co.il': 'prihadar',
  'vrt.be': 'vrt',
  'news.co.uk': 'newscorpuk',
  'wh-m.at': 'whmedia',
  'fiaformulae.com': 'formulae',
  'formulae.com': 'formulaestaging',
  'nylife.com': 'nylife',
  'hilton.com': 'hilton',
  'hiltonstaging.com': 'hiltonstaging',
  'eagles.nfl.com': 'eagles',
  'swr.de': 'swr',
  'yle.fi': 'yle',
  'gbnews.uk': 'gbnews',
  'rtl.nl': 'rtlnetherlands',
  'ncadummy.com': 'nca',
  'ncasitdummy.com': 'ncasit',
  'ncauatdummy.com': 'ncauat',
  'education.nsw.gov.au': 'nswdoe',
  'sbgtv.com': 'sbgtv',
  'zdf.de': 'zdfpoc',
  'tv2.no': 'tv2no',
  'cbsnewsarchive.com': 'cbsnewsarchive',
  'cbsnyc.com': 'cbsnyc',
  'yahooinc.com': 'yahoofinance',
  'nbcuni.com': 'nbcu',
  'onemimir.com': 'mimir',
  'plppoc.com': 'plppoc',
  'ouest-france.fr': 'ouestfrance',
};

/**
 * Hard code organizations by either domain or tenantId, which will allow us to provide a more
 * user friendly description of the organization.
 *
 * If we detect a tenant in the URL parameter "organization", and that tenantId is not part of this list,
 * we default to capitalizing the tenantId as a description.
 */
export const organizationLoginDetails: Record<string, TenantDescription> = {
  'mimir.emerson.edu': { tenantId: 'emerson', tenantDescription: 'Emerson' },
  'emerson': { tenantId: 'emerson', tenantDescription: 'Emerson' },
  'mediability': { tenantId: 'mediability', tenantDescription: 'Fonn Group' },
  'tv2east': { tenantId: 'tv2east', tenantDescription: 'TV2 ØST' }
};
